export default __webpack_public_path__ + "static/media/img_about-papa.dfa32231.jpg";